import {
  SET_DINER_DETAILS,
  SET_CHEF_DETAILS,
  SET_DINER_PAYMENTINFO,
  SET_SAVED_CHEFS,
  SET_SAVED_DISHES,
  SET_SAVED_POSTS,
  SET_USER_REVIEW_TAGS,
  SET_CHEF_REVIEW_TAGS,
  SET_VIEW_AS_DINER
} from "../stateConstants";
import { client } from "../../config/apollo";
import {
  GET_USER,
  GET_USER_PAYMENT,
  GET_SAVED_CHEFS,
  GET_SAVED_DISHES,
  GET_SAVED_POSTS,
  USER_REVIEW,
  CHEF_REVIEW
} from "../../graphql/queries/user";

import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";

const initialState = {
  diner: null,
  chef: null,
  paymentInfo: null,
  savedChefs: [],
  savedDishes: [],
  savedPosts: [],
  userReview: [],
  chefReview: [],
  viewAsDiner: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DINER_DETAILS:
      return {
        ...state,
        diner: action.result
      };

    case SET_CHEF_DETAILS:
      return {
        ...state,
        chef: action.result
      };

    case SET_DINER_PAYMENTINFO:
      return {
        ...state,
        paymentInfo: action.result
      };

    case SET_SAVED_CHEFS:
      return {
        ...state,
        savedChefs: action.result
      };

    case SET_SAVED_DISHES:
      return {
        ...state,
        savedDishes: action.result
      };

    case SET_SAVED_POSTS:
      return {
        ...state,
        savedPosts: action.result
      };

    case SET_USER_REVIEW_TAGS:
      return {
        ...state,
        userReview: action.result
      };

    case SET_CHEF_REVIEW_TAGS:
      return {
        ...state,
        chefReview: action.result
      };

    case SET_VIEW_AS_DINER:
      return {
        ...state,
        viewAsDiner: action.result
      };

    default:
      return state;
  }
};

export default reducer;

export const getUser = userId => {
  return (dispatch, getState) => {
    let data = "";
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_USER,
        variables: {
          id: userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.user) {
          data = result.data.user;
        }

        dispatch({
          type: SET_DINER_DETAILS,
          result: data
        });
      })
      .catch(err => {
        console.log(JSON.parse(JSON.stringify(err)));
      });
  };
};

export const getChef = userId => {
  return (dispatch, getState) => {
    let data = "";
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_CHEF_DETAILS,
        variables: {
          id: userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.chef) {
          data = result.data.chef;
        }
        dispatch({
          type: SET_CHEF_DETAILS,
          result: data
        });
      });
  };
};

export const getPaymentInfo = userId => {
  return (dispatch, getState) => new Promise((resolve, reject) => {
    let data = "";
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_USER_PAYMENT,
        variables: {
          userId: userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.userPaymentMethods) {
          data = result.data.userPaymentMethods;
        }

        resolve(dispatch({
          type: SET_DINER_PAYMENTINFO,
          result: data
        }));
      })
      .catch(err => {
          reject(err);
        console.log(JSON.parse(JSON.stringify(err)));
        dispatch({
          type: SET_DINER_PAYMENTINFO,
          result: null
        });
      });
  });
};

export const getSavedChefs = userId => {
  return (dispatch, getState) => {
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_SAVED_CHEFS,
        variables: {
          userId,
          pageSize: 100
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.savedChefs) {
          dispatch({
            type: SET_SAVED_CHEFS,
            result: result.data.savedChefs.chefs
          });
        }
      });
  };
};

export const getSavedDishes = userId => {
  return (dispatch, getState) => {
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_SAVED_DISHES,
        variables: {
          userId,
          pageSize: 100
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.savedDishes) {
          dispatch({
            type: SET_SAVED_DISHES,
            result: result.data.savedDishes.dishes
          });
        }
      });
  };
};

export const getSavedPosts = userId => {
  return (dispatch, getState) => {
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: GET_SAVED_POSTS,
        variables: {
          userId,
          pageSize: 100
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.savedPosts) {
          dispatch({
            type: SET_SAVED_POSTS,
            result: result.data.savedPosts.posts
          });
        }
      });
  };
};

export const getUserReviewTags = userId => {
  return (dispatch, getState) => {
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: USER_REVIEW,
        variables: {
          userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.reviewTagsForChef) {
          dispatch({
            type: SET_USER_REVIEW_TAGS,
            result: result.data.reviewTagsForChef
          });
        }
      });
  };
};

export const getChefReviewTags = userId => {
  return (dispatch, getState) => {
    if (!userId) {
      userId = getState().auth.userId;
    }

    client
      .query({
        query: CHEF_REVIEW,
        variables: {
          userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.reviewTagsForUser) {
          dispatch({
            type: SET_CHEF_REVIEW_TAGS,
            result: result.data.reviewTagsForUser
          });
        }
      });
  };
};

export const setViewAsDiner = viewAsDiner => {
  return dispatch => {
    dispatch({
      type: SET_VIEW_AS_DINER,
      result: viewAsDiner
    });
  };
};
